
import onboardingWindow from '~/components/onboarding/window.vue';
export default {
  components: {
    onboardingWindow
  },
  layout: 'onboarding',
  auth: false,
  props: {
    modal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loading: false,
      errorMessage: '',
      user: {
        email: this.$route.query.email,
        password: ''
      }
    };
  },

  async mounted () {
    try {
      if ('PasswordCredential' in window && !this.$auth.loggedIn) {
        const credential = await navigator.credentials.get({
          password: true,
          mediation: 'optional'
        });
        if (!credential) { return; }

        this.user = {
          email: credential.id,
          password: credential.password
        };

        this.login();
      }
    } catch (e) {
      console.error(e);
    }
  },

  methods: {
    selectTeam (team) {
      this.$user.changeTeam(team.id, true);

      this.$store.dispatch('onLogin');

      this.gotoHome();
    },

    gotoHome () {
      if (this.$route.path !== '/login') {
        location.reload();
        return;
      }

      const redirectUrl = this.$route.query.redirect ?? sessionStorage.getItem('redirect_url') ?? '/';
      sessionStorage.removeItem('redirect_url');

      this.$router.replace(redirectUrl);
    },

    forgotPassword () {
      this.$router.push({
        path: '/login/forgot-password',
        query: {
          email: this.user.email
        }
      });
    },

    async login (e) {
      this.errorMessage = '';
      const { email, password } = this.user;
      try {
        this.loading = true;

        const { token } = await this.$axios.$post(`${this.$config.authApi}/authorization/login`, {
          email,
          password,
          grant_type: 'password'
        });

        await this.$auth.setUserToken(token);

        if ('PasswordCredential' in window) {
          const credential = new window.PasswordCredential({
            id: email,
            name: `${this.$auth.user.firstName} ${this.$auth.user.lastName}`,
            password,
            iconURL: this.$auth.user.profilePictureUrl ?? undefined
          });

          navigator.credentials.store(credential);
        }

        if (this.$auth.user.teams.length === 1) {
          this.selectTeam(this.$auth.user.teams[0]);
        } else {
          const redirect = this.$route.query.redirect;
          if (redirect) {
            sessionStorage.setItem('redirect_url', redirect);
          }

          this.$router.replace('/login/team');
        }
      } catch (e) {
        console.error(e);

        if (
          e.response.data.error_description ===
          'The user does not belong to any teams.'
        ) {
          this.errorMessage =
          'Je zit in geen enkel team. Neem contact met ons op.';
          return;
        } else if (e.response.status === 500) {
          this.errorMessage = 'Altura heeft technische problemen op dit moment.';
        } else {
          this.errorMessage = 'Wachtwoord of gebruikersnaam is incorrect.';
        }
      }
      this.loading = false;
    },

    logout () {
      this.$store.commit('reset');
      this.$auth.logout();
      this.view = 'login';
    }
  }
};
